const data = {
  'Selected': '선택된 항목: {0}/{1}',
  'Uploading files': '{1} 중 {0}% 업로드 진행',
  'File size error': '{1} 이하의 파일만 업로드가 가능합니다.',
  'Upload failed': '{0} 업로드 실패',
  'Upload summary': '성공 {0}, 실패 {1}, 총 {2}',
  'Per page': '{0}개씩 보기',
  'Folder': '폴더',
  'Login failed, please try again': '로그인 실패, 다시 시도하십시오.',
  'Already logged in': '이미 로그인되었습니다.',
  'Please enter username and password': '사용자 이름과 비밀번호를 입력하십시오.',
  'Not Found': '찾을 수 없음',
  'Not Allowed': '허용되지 않음',
  'Please log in': '로그인하십시오.',
  'Unknown error': '알 수 없는 오류',
  'Add files': '업로드',
  'New': '생성',
  'New name': '변경할 이름',
  'Username': '사용자 이름',
  'Password': '비밀번호',
  'Login': '로그인',
  'Logout': '로그아웃',
  'Profile': '프로필',
  'No pagination': '전체 보기',
  'Time': '수정한 날짜',
  'Name': '이름',
  'Size': '크기',
  'Home': '홈',
  'Copy': '복사',
  'Move': '이동',
  'Rename': '이름 변경',
  'Required': '이 필드를 작성하십시오.',
  'Zip': '압축',
  'Batch Download': '일괄 다운로드',
  'Unzip': '압축 해제',
  'Delete': '삭제',
  'Download': '다운로드',
  'Copy link': '링크 복사',
  'Done': '완료',
  'File': '파일',
  'Drop files to upload': '업로드할 파일을 끌어서 놓으십시오.',
  'Close': '닫기',
  'Select Folder': '폴더 선택',
  'Users': '사용자',
  'Files': '파일',
  'Role': '역할',
  'Cancel': '취소',
  'Paused': '일시중지됨',
  'Confirm': '확인',
  'Create': '생성',
  'User': '사용자',
  'Admin': '관리자',
  'Save': '저장',
  'Read': '읽기',
  'Write': '쓰기',
  'Upload': '업로드',
  'Permissions': '권한',
  'Homedir': '홈 폴더',
  'Leave blank for no change': '변경하지 않으려면 비워 두십시오.',
  'Are you sure you want to do this?': '이 작업을 수행하시겠습니까?',
  'Are you sure you want to allow access to everyone?': '방문자에게 접근을 허용하시겠습니까?',
  'Are you sure you want to stop all uploads?': '모든 업로드를 중지하시겠습니까?',
  'Something went wrong': '오류가 발생했습니다.',
  'Invalid directory': '잘못된 폴더',
  'This field is required': '이 필드는 필수입니다.',
  'Username already taken': '이미 사용 중인 사용자 이름입니다.',
  'User not found': '사용자를 찾을 수 없습니다.',
  'Old password': '현재 비밀번호',
  'New password': '새 비밀번호',
  'Wrong password': '잘못된 비밀번호',
  'Updated': '업데이트됨',
  'Deleted': '삭제됨',
  'Your file is ready': '파일이 준비되었습니다.',
  'View': '보기',
  'Search': '검색',
  'Download permission': '다운로드',
  'Guest': '방문자',
  'Show hidden': '숨김 표시',
  'Show symbolic format': '기호 형식 표시',
  'Hide symbolic format': '기호 형식 숨기기',
}

export default data

